<script setup>
import { ref, watch, useAttrs } from 'vue';
import { debounce, Notify } from 'quasar';
import { useClipboard } from '@vueuse/core';

const attrs = useAttrs();
const source = ref(attrs.text);
const { text, copy, copied, isSupported } = useClipboard({ source });

const menu = ref(false);
const menuOver = ref(false);
const listOver = ref(false);

const debounceFunc = debounce(checkMenu, 10);

function checkMenu() {
  if (menuOver.value || listOver.value) {
    menu.value = true;
  } else {
    menu.value = false;
  }
}
watch([menuOver, listOver], () => {
  debounceFunc();
});

function copying(v) {
  source.value = v;
  copy();
  Notify.create({
    message: 'Text Copied!',
    classes: 'bg-green px-4',
  });
}
</script>

<template>
  <div
    @mouseover="menuOver = true"
    @mouseout="menuOver = false"
    class="text-primary"
  >
    View
    <q-menu v-model="menu" persistent auto-close>
      <q-list
        style="min-width: 100px"
        dense
        @mouseover.native="listOver = true"
        @mouseout.native="listOver = false"
        separator
      >
        <q-item>
          {{
            $attrs.field.startsWith('finance')
              ? 'Finance Details'
              : 'Bank Details'
          }}
        </q-item>
        <q-item class="relative" v-for="(item, key) in $attrs.data">
          <div class="font-semibold">{{ key }}</div>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>
